import ChannelHeader from './ChannelHeader';

export default ChannelHeader;
